// CACHE BUST v3.0 - About page with integrated "What Working Together Looks Like" section
import React from 'react';
import { Link } from 'react-router-dom';
export default function AboutPage() {
  return <div className="min-h-screen bg-white">
      {/* Hero Section with Photo */}
      <section className="relative pt-32 pb-20 md:pb-32 overflow-hidden">
        {/* Background Image with Overlay - Same as homepage */}
        <div className="absolute inset-0 z-0">
          <img src="https://images.squarespace-cdn.com/content/v1/5e7be0f4a4a1a06a00b2ccbf/fccc9623-36d4-4abb-aaf3-d2d3604d854f/unsplash-image-GN3V3OkWO7Q.jpg?format=1500w" alt="Peaceful nature background" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-sage-900/70 via-sage-800/60 to-sage-900/70"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Photo */}
            <div className="order-2 md:order-1">
              <div className="relative">
                <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl ring-4 ring-white/20">
                  <img src="https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_1200,f_auto,q_auto:best,fl_preserve_transparency,dpr_2/https%3A%2F%2Fmaker-devi-dev.s3-accelerate.amazonaws.com%2Fuploads%2Fuser_33tbl7B6e1bXN6KW4wjrevvqrth%2Fk6madjzd5jwco436pgy5kok0%2Fmessages%2Fyasi-headshots-072121-27-b0x892lrlge.jpg" alt="Professional headshot" className="w-full h-full object-cover" />
                </div>
                {/* Decorative glow */}
                <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-warm-400/20 rounded-full -z-10 blur-2xl"></div>
              </div>
            </div>
            
            {/* Intro Text */}
            <div className="order-1 md:order-2 text-center md:text-left">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-white mb-6 leading-tight">
                I'm Yasi.
              </h1>
              
              <p className="text-xl md:text-2xl text-cream-100 mb-8 leading-relaxed text-balance">I help women stop people-pleasing, reclaim their authority, and love, lead, and live authentically. 
I am a recovering people-pleaser.</p>
              
              <Link to="/#booking" className="inline-block px-8 py-4 bg-warm-500 text-white rounded-full text-base font-semibold hover:bg-warm-600 transition-all duration-300 hover:shadow-2xl hover:scale-105 transform"><span>
                Book a Free Consultation
              </span></Link>
            </div>
          </div>
        </div>
      </section>

      {/* My Approach Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8 text-gray-900">
            
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
              My Approach
            </h2>

            {/* Philosophy */}
            <div className="space-y-4">
              <p className="text-xl md:text-2xl font-semibold text-sage-800 italic text-balance">
                My space. My pace.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-balance">
                <strong>I am always a student of my clients.</strong>
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-balance">
                You are the expert on your life situations, challenges, and your body.<br />
                I bring my expertise as a professional.<br />
                Together, we collaborate and attune to the wisdom of your body and nervous system.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                In our sessions, everything you bring is welcome...<br />
                Your feelings.<br />
                Your doubts.<br />
                And any anxieties around things changing.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                We'll go at your pace, and I'll meet you right where you are.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                <strong>I believe all of you is good.</strong><br />
                No parts of us are bad... and we have parts that learned to protect us in the best way they knew how.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">When we meet these parts with compassion and curiosity instead of criticism, they begin to relax. And that's where healing begins... not by pushing any part away, but by letting every part of you feel seen, understood, valued, appreciated, accepted, and safe.</p>
            </div>

            {/* Cultural Awareness */}
            <div className="space-y-4 border-l-4 border-warm-400 pl-6">
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">Our different cultures, identities, and systems significantly shape our experiences.</p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                As an Asian Indian immigrant who moved to the US at 18, I understand what it's like to navigate cultural expectations, family systems, and the pressure to be the "good daughter", "good wife", "good friend", and "good employee" while finding your own voice.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                I care deeply about creating a space where <strong>all</strong> parts of who you are feel respected and seen.
              </p>
            </div>

            {/* What Working Together Looks Like */}
            <div className="mt-12 pt-8 border-t-2 border-warm-200">
              <h3 className="text-3xl md:text-4xl font-bold text-sage-800 mb-6">
                What Working Together Looks Like
              </h3>
              
              <div className="space-y-6">
                <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                  I love to support women in improving their relationship with themselves—by <strong>embracing and fiercely loving all parts of themselves</strong>, even the ones that can be hard to love or feel self-limiting, especially the inner critic and people-pleaser.
                </p>
                
                <div className="bg-sage-50 rounded-xl p-6 my-8">
                  <h4 className="text-2xl font-semibold text-sage-800 mb-4">
                    Body-Centered Healing
                  </h4>
                  <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-4">
                    An important part of my work includes <strong>helping you listen and learn what's happening at your nervous system level</strong> as we are together.
                  </p>
                  <p className="text-base md:text-lg text-gray-700 leading-relaxed">When you work with me, you will practice tracking the ebbs and flows of your nervous system—learning to listen to and attune to the wisdom of your body. In session with me, there is silence interspersed with the talking so that shifts in the body are given space. I guide you in how to use this space so we can listen and understand what your body is saying.</p>
                </div>
                
                <div className="bg-sage-50 rounded-xl p-6 my-8">
                  <h4 className="text-2xl font-semibold text-sage-800 mb-4">
                    Strength Based
                  </h4>
                  <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                    My approach helps you tap into your existing strengths and internal resources, including those you may not yet recognize.
                  </p>
                </div>
                
                <div className="bg-warm-50 rounded-xl p-6 my-8">
                  <h4 className="text-2xl font-semibold text-warm-700 mb-4">
                    Creating Sustainable Change
                  </h4>
                  <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-4">
                    Real change doesn't happen all at once—it's built through small, steady shifts that your body can trust. I'll help you create supportive habits and routines using micro-habit formation and habit stacking, so growth feels natural, not overwhelming.
                  </p>
                  <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4">
                    As we move through your process, I'll guide you through the obstacles that arise and help you keep making progress at a pace that feels right for your nervous system. You decide when to pause, slow down, or rest. If anxiety shows up, we listen to it—using body-centered practices to regulate, recalibrate, and return to safety before moving forward.
                  </p>
                  <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                    Each step honors your capacity, helping change take root in a way that's sustainable, compassionate, and embodied.
                  </p>
                </div>
                
                {/* Relational Mindfulness for Leaders */}
                <div className="bg-gradient-to-r from-sage-100 to-warm-100 rounded-xl p-8 my-8 shadow-lg border-2 border-sage-300">
                  <h4 className="text-2xl md:text-3xl font-bold text-sage-800 mb-4">
                    Relational Mindfulness for Leaders
                  </h4>
                  <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                    If you are a therapist, supervisor, manager, spiritual director, or coach or parent, we can focus our work on cultivating your relational mindfulness. We would be focusing on gently increasing your capacity to lead others — becoming more attuned to interpersonal dynamics and social/emotional cues of others—so you can engage with others from compassion curiosity, empathy, understanding, and ease.
                  </p>
                </div>
                
                <div className="border-l-4 border-warm-400 pl-6 py-4">
                  <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-4">
                    <strong>AND</strong>
                  </p>
                  <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                    You'll have my full support and steady encouragement as you learn yourself and make shifts that lead to real, sustainable change. I'll be here, celebrating your progress—sometimes with a happy dance!
                  </p>
                </div>
                
                <div className="text-center mt-8 p-8 bg-gradient-to-r from-sage-100 to-warm-100 rounded-2xl">
                  <p className="text-2xl md:text-3xl font-semibold text-sage-800 italic leading-relaxed">
                    With me, you practice learning to love all of you.<br />
                    You practice getting behind and supporting all of you.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Modalities Section */}
      <section className="py-20 bg-gradient-to-r from-sage-50 to-warm-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 text-center">
            Therapeutic Modalities
          </h2>
          
          {/* Intro Text */}
          <div className="max-w-3xl mx-auto text-center mb-12">
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              <strong>I offer more than just talk therapy.</strong> I use research-informed and neuroscience-based approaches to address underlying trauma, including <strong>Internal Family Systems (IFS)</strong> and <strong>Polyvagal-informed nervous system work</strong>. These approaches address the traumatic roots of symptoms and behaviors.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
            {/* Polyvagal Theory */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <h3 className="text-2xl font-bold text-warm-600 mb-4">
                Polyvagal Theory
              </h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4">
                Polyvagal Theory helps us understand how the nervous system responds to safety and threat, and how dysregulation shows up as people-pleasing or fawning, which is an automatic nervous system stress response state.
              </p>
              <p className="text-gray-600">
                Through gentle practices like vagus nerve stimulation, we build your nervous system's capacity to feel safe enough to set boundaries—without defaulting to people-pleasing or fawning. We work on both self-regulation and co-regulation, creating safety within your own body and in relationship with others.
              </p>
            </div>
            
            {/* IFS */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <h3 className="text-2xl font-bold text-warm-600 mb-4">
                Internal Family Systems (IFS)
              </h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4">
                IFS helps you understand the different "parts" of yourself and how they work together. This compassionate approach helps heal internal conflicts and nervous system dysregulation.
              </p>
              <p className="text-gray-600">
                IFS is especially helpful for people-pleasers, as it helps you understand the parts that drive you to overfunction and teaches you to access your authentic Self. Through IFS, we help your parts connect with each other in kind and safe ways, creating an increased sense of safety within your own system.
              </p>
            </div>
            
            {/* Attachment-Based Therapy */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <h3 className="text-2xl font-bold text-warm-600 mb-4">
                Attachment-Based Therapy
              </h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4">
                Understanding your attachment style helps make sense of patterns in relationships and how nervous system dysregulation impacts your ability to connect with others.
              </p>
              <p className="text-gray-600">
                We explore how early relationships shaped your beliefs about yourself and others, and work to develop more secure ways of relating. Through understanding attachment, we build capacity for co-regulation—feeling safe in your body while being in relationship with others.
              </p>
            </div>
            
            {/* Somatic Therapy */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <h3 className="text-2xl font-bold text-warm-600 mb-4">
                Somatic Approaches
              </h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4">
                Trauma lives in the body. Somatic therapy helps you tune into body sensations and release stored tension and emotions that drive nervous system dysregulation.
              </p>
              <p className="text-gray-600">I incorporate body-based techniques to help you develop awareness of how emotions show up physically and learn to regulate your nervous system. Through somatic work, we create safety in your body, building your capacity for self-regulation, increasing resilience, emotional intelligence.</p>
            </div>
          </div>
          
          {/* Additional Modalities */}
          <div className="mt-12 bg-white rounded-xl shadow-lg p-8 max-w-5xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Additional Training & Approaches
            </h3>
            <div className="space-y-8 text-gray-700">
              <div>
                <h4 className="text-2xl font-bold text-warm-600 mb-4">Cognitive Behavioral Therapy (CBT)</h4>
                <p className="text-base md:text-lg text-gray-600">Identifying and changing unhelpful thought patterns that fuel anxiety and self-doubt.</p>
              </div>
              
              <div>
                <h4 className="text-2xl font-bold text-warm-600 mb-4">Dialectical Behavior Therapy (DBT)</h4>
                <p className="text-base md:text-lg text-gray-600">Building skills for emotional regulation, distress tolerance, and interpersonal effectiveness.</p>
              </div>
              
              <div>
                <h4 className="text-2xl font-bold text-warm-600 mb-4">Mindfulness-Based Stress Reduction</h4>
                <p className="text-base md:text-lg text-gray-600">Cultivating present-moment awareness to reduce stress and increase self-compassion.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experience & Education Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16">
            {/* Left Column */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
                Experience & Education
              </h2>
            </div>
            
            {/* Right Column */}
            <div className="space-y-6 text-base md:text-lg text-gray-700 leading-relaxed">
              <p>
                I earned my Master's degree in Counseling Psychology from <strong>Santa Clara University</strong> and am a Licensed Marriage & Family Therapist (LMFT) in California (License #105168).
              </p>
              
              <p>My clinical experience includes working with individuals, couples, and families dealing with relational and cultural trauma, post-traumatic stress disorder, attentional-deficit diagnoses, anxiety disorders including panic attacks and phobias, depression, suicidality, bipolar disorders, relationship challenges, and life transitions.</p>
              
              <p>I'm committed to ongoing professional development and regularly engage in trainings, consultation, and workshops to stay current with the evolving research and body-based approaches that support safe, effective, compassionate care.</p>
              
              <p>I am passionate about destigmatizing seeking support for what is often called "mental health." The term is limiting—our brain is part of our body, and calling it "mental health" separates it from the rest of who we are. This can make it harder for people to feel fully seen and supported when seeking care.</p>

            </div>
          </div>
        </div>
      </section>

      {/* Personal Note Section */}
      <section className="py-20 bg-gradient-to-r from-sage-50 to-warm-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-8 text-sage-800">
                On a Personal Note
              </h2>
            </div>
            
            <div className="space-y-6 text-base md:text-lg leading-relaxed text-sage-700">
              <p>I am an Asian Indian immigrant who grew up in Chandigarh, Punjab, India, and moved to the United States when I was 18. This experience deeply shapes how I understand cultural expectations, family systems, and the unique pressures of navigating between two worlds.</p>
              
              <p>I've been married to my wonderful partner for 19 years. We live in East Palo Alto, California with our baby girl and our puppy. As a family, we enjoy doing life together with our neighbors as part of a connected community.</p>
              
              <p>For fun, I like to watch movies, listen to music, chat with friends over walks and chai, take on interior design projects at home, and play with my babies.</p>
              
              <p>I believe in this work I do because receiving this kind of somatic work, therapy, coaching, spiritual direction, and mentoring from others has greatly improved my own life. I have personally benefited from the tools I offer and understand the courage it takes to seek support.</p>
              
              <p>
                I understand the unique pressures of living in the Bay Area—the high-achieving culture, the fast pace, and the challenges of maintaining balance while staying true to yourself. I'm here to help you navigate these challenges while honoring all parts of your identity.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ready to Start Your Journey?
          </h2>
          <p className="text-xl text-gray-700 mb-10 leading-relaxed">
            I offer a free 15-minute consultation to see if we're a good fit. There's no pressure—just an opportunity to ask questions and learn more about how I can help.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/booking" className="inline-block bg-warm-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-warm-600 transition-colors text-lg shadow-lg hover:shadow-xl"><span>
              Schedule Consultation
            </span></Link>
            <Link to="/#services" className="inline-block bg-white text-warm-600 border-2 border-warm-500 px-8 py-4 rounded-lg font-semibold hover:bg-warm-50 transition-colors text-lg"><span>
              Learn About Services
            </span></Link>
          </div>
        </div>
      </section>
    </div>;
}